module.exports = __webpack_public_path__ + "static/media/box-number-brown.de5501f5.png";